module.exports = __webpack_public_path__ + "img/section_6.d9943195.png";